import React, { Component } from 'react';
import { connect } from 'react-redux';

import Swal from 'sweetalert2';

import Button from 'Flow2/components/UI/Button/Button';
import ButtonStyle from 'Flow2/components/UI/Button/Button.module.scss';

import FlexRow from 'Flow2/components/UI/Container/FlexRow';
import FlexColumn from 'Flow2/components/UI/Container/FlexColumn';
import TagsTree from 'Flow2/components/TagsTree/TagsTree';

import Checkbox from 'Flow2/components/UI/Checkbox/Checkbox';
import Input from 'Flow2/components/UI/Input/Input';

import classes from './Masterdata.module.scss';
import * as actions from 'store/actions/index';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import StructureMapping from 'Flow2/util/StructureMapping.js';
import MetadataLanguage from 'Flow2/util/MetadataLanguage.js';
import MetadataElementHelper from 'Flow2/util/MetadataElementHelper.js';
import MetadataPermissionHelper from 'Flow2/util/MetadataPermissionHelper.js';

import { IntlProvider, FormattedMessage, injectIntl, addLocaleData } from 'react-intl';
import locale_en from 'react-intl/locale-data/en';
import locale_de from 'react-intl/locale-data/de';
import deTranslation from "PMDB/assets/languages/de.json";
import enTranslation from "PMDB/assets/languages/en.json";

import { de } from 'date-fns/locale/de';
import { format, isValid } from 'date-fns';
import Spinner from 'Flow2/components/UI/Spinner/Spinner';
import { isTranscoder1 } from "Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil";
//registerLocale('de', de);

import RoomSetting from "Flow2/components/Metadata/RoomSetting";

import * as Panel from 'Flow2/containers/Panel/Panel';

export const OBJECT_TYPE_CLIP = 'clip';
export const OBJECT_TYPE_ROOM = 'room';
export const OBJECT_TYPE_PROJECT = 'project';
export const OBJECT_TYPE_DISTRIBUTION = 'distribution';
export const OBJECT_TYPE_MEDIAFILE = 'mediafile';
export const OBJECT_TYPE_NEWSROOM = 'newsroom';
export const OBJECT_TYPE_SERIES = 'series';

export const METADATA_MODE_TEXT = 'text';
export const METADATA_MODE_EDIT = 'edit';
const METADATA_MODE_CANCEL = 'cancel';

export const METADATA_CONTENT_METADATA = "METADATA_CONTENT_METADATA";
export const METADATA_CONTENT_SETTING = "METADATA_CONTENT_SETTING";

class Metadata extends Component {

    structures = {}
    checkbox = {}    // internal structure to handle checkbox values

    defaults = {
        datefield: "",
        checkbox: "0",
        state: {
            updated: false,
            mode: METADATA_MODE_TEXT,   // text for display, edit for editable
			content: METADATA_CONTENT_METADATA
        }
    }

    constructor(props) {
        super(props);
        this.languageHelper = new MetadataLanguage(this.props.config.languages, this.props.config.defaultLanguage);
        this.state = { ...this.defaults.state, ...this.initState(props) }
        this.structures = { ...this.initInternalStructures(props) };
        MetadataPermissionHelper.hasDeletePermission(props);
    }

    initState = (props) => {
        const state = {};

        state.tabs = props.tabs || [];
        state.lang = this.languageHelper.getInitialLang(props.appLang);
        state.elements = StructureMapping.getUsedElements(props.type, props.data, state.tabs);
        state.fail = props.conditional;
        state.failMessage = props.message;

        return state;
    }

    initInternalStructures = (props) => {
        const structures = {};

        structures.tabs = StructureMapping.createTabStructure(props.type);
        structures.lang = StructureMapping.createLangStructure(props.type, props.config.languages);
        structures.checkbox = StructureMapping.createCheckboxStructure(props.type, props.data);
        structures.remove = StructureMapping.createRemoveStructure(props.type, props.data);

        return structures;
    }

    componentDidMount = () => {
        this.props.loadUsers();
    }

    getValue = (field) => {
        if (field && this.state.elements.hasOwnProperty(field)) {
            return this.state.elements[field];
        }
        return "";
    }

    toggleMetadata = () => {
        if (this.props.viewState === Panel.PANEL_VIEW_STATE_OPEN) {
            this.props.closed();
        } else {
            this.props.opened();
        }
    }

    toggleMode = (mode) => {
        switch (mode) {
            case METADATA_MODE_TEXT:
                this.setState({ updated: false, mode: METADATA_MODE_EDIT });
                break;
            case METADATA_MODE_EDIT:
                if (this.state.updated) {
                    
					let elements = {};
					if(this.props.type === Metadata.OBJECT_TYPE_CLIP) {
						elements = { ...this.props.data, ...this.state.elements };
					} else {
						elements = { ...this.state.elements };
					}
					
                    // remove entries which will not be saved
                    this.structures.remove.forEach(item => {
                        if (elements.hasOwnProperty(item)) {
                            delete elements[item];
                        }
                    });

                    const fail = this.checkFieldConditions(elements);
                    
                    if(!fail.length) {
                        let reloads = null;
                        const components = this.checkReload(elements);
                        if(components) {
                            reloads = { components: components, id: this.props.projectId };
                        }
                        this.props.updateMetadata(this.props.type, this.props.id, elements, reloads);
                        
                        this.setState({ fail: [], failMessage: "" });
                    } else {
                        this.setState({ fail: fail, failMessage: "popup.title.mandatory.fail" });
                    }
                }

                this.setState({ updated: false, mode: METADATA_MODE_TEXT });
                break;
            case METADATA_MODE_CANCEL:
                this.setState({ updated: false, mode: METADATA_MODE_TEXT });
                break;
            default:
                this.setState({ updated: false, mode: METADATA_MODE_TEXT });
                break;
        }
    }
    
    checkFieldConditions = (elements) => {
        let fail = [];
        for(let key in elements) {
            let obj = StructureMapping.getField(this.props.type, key);
            let condition = StructureMapping.isCondition(obj);
            if(condition && !MetadataElementHelper.isConditionSuccess(condition, elements)) {
                elements[key] = "";
                if(this.structures.checkbox[key]) {
                    for(let value in this.structures.checkbox[key]) {
                        this.structures.checkbox[key][value] = false;
                    }
                }
            }
            
            if(StructureMapping.isMandatoryEdit(obj)) {
                if(!condition && !elements[key]) {
                    fail.push(key);
                } else {
                    if(condition && MetadataElementHelper.isConditionSuccess(condition, elements) && !elements[key]) {
                        fail.push(key);
                    }
                }
            }
        }
        return fail;
    }
    
    checkReload = (elements) => {
        let reloads = [];
        for(let key in elements) {
            let obj = StructureMapping.getField(this.props.type, key);
            let reload = StructureMapping.isReload(obj);
            if(reload && reloads.indexOf(reload) === -1) {
                reloads.push(reload);
            }
        }
        return reloads;
    }
	
	showMandatoryMessage = () => {
        if(this.state.fail.length && this.state.failMessage) {
            Swal.fire({
                title: this.props.intl.formatMessage({ id: this.state.failMessage }),
                //text: this.props.intl.formatMessage({ id: "popup.message.clips.remove" }),
                confirmButtonText: this.props.intl.formatMessage({ id: "common.ok" }),
                confirmButtonClass: [ButtonStyle.Button, ButtonStyle.Red].join(' '),
                buttonsStyling: false
            }).then((res) => {
                if (res.value) {
                    this.setState({ failMessage: "" });
                }
            });
        }
	}

    toggleLang = (lang) => {
        const newLang = this.languageHelper.switchLang(lang);
        this.setState({ lang: newLang });
    }
	
	toggleContent = (content) => {
		this.setState({ content: content, mode: METADATA_MODE_TEXT });
	}

    createCheckboxStructure = (element, options, values) => {
        this.structures.checkbox[element] = {};
        for (let key in options) {
            if (values.includes(key)) {
                this.structures.checkbox[element][key] = true;
            } else {
                this.structures.checkbox[element][key] = false;
            }
        }
    }

    inputChangedHandler = (value, element) => {
        const ReleasedElement = {
            ...this.state.elements,
            [element]: value.replace(/; /g, ';')
        };

        this.setState({ elements: ReleasedElement, updated: true });
    }

    dateChangedHandler = (date, element) => {
        let dateString = this.defaults.datefield;
        if (date !== null) {
            dateString = format(date, 'YYYY-MM-DD');
        }

        const updatedElement = {
            ...this.state.elements,
            [element]: dateString
        };

        this.setState({ elements: updatedElement, updated: true });
    }

    checkboxChangeHandler = (element, key) => {
        if (!this.structures.checkbox[element]) {
            return;
        }

        this.structures.checkbox[element][key] = !this.structures.checkbox[element][key];
        let value = this.createValueString(element);

        // workaround for single checkboxes with default value 0 if not checked
        if (value === "" && this.structures.checkbox[element] && Object.keys(this.structures.checkbox[element]).length === 1) {
            value = this.defaults.checkbox;
        }

        this.setState(state => {
            state.elements[element] = value
            state.updated = true
            return state
        });
    }

    addListHandler = (input, element) => {
        // TODO: check input email
        // Move this method to elementHelper

        if (input !== '') {
            this.props.addMemberToProject(this.props.id, input);

            input = (this.state.elements[element]) ? input + ';' + this.state.elements[element] : input;

            const ReleasedElement = {
                ...this.state.elements,
                [element]: input
            };

            this.setState({ elements: ReleasedElement, updated: true });
        }
    }

    removeListHandler = (index, element) => {
        // TODO: handle remove
        // Move this method to elementHelper

        let x = this.state.elements[element].split(';');
        this.props.delMemberFromProject(this.props.id, x[index]);
        x.splice(index, 1);
        x = x.join(';');

        const ReleasedElement = {
            ...this.state.elements,
            [element]: x
        }

        this.setState({ elements: ReleasedElement, updated: true });
    }

    // create string from checkbox values to save in backend
    createValueString = (element) => {
        let value = "";
        for (let key in this.structures.checkbox[element]) {
            if (this.structures.checkbox[element][key]) {
                if (value !== "") {
                    value += ";" + key;
                } else {
                    value += key;
                }
            }
        }
        return value;
    }

    tagTreeAddHandler = (values, addedTag) => {
        this.tagTreeChangeHandler(values);
    }

    tagTreeRemoveHandler = (values, removedTag) => {
        this.tagTreeChangeHandler(values);
    }

    tagTreeChangeHandler = (values) => {
        const ReleasedElement = {
            ...this.state.elements,
            ...values
        };

        this.setState({ elements: ReleasedElement, updated: true });
    }
	

    createMetadata = () => {
        if (this.props.viewState !== Panel.PANEL_VIEW_STATE_OPEN) {
            return '';
        }

        let content = [];
        for (let tab in this.state.tabs) {
            const tableElementsArray = this.createElements(this.state.tabs[tab]);

            let section = [];
            section.push(<tr key={this.state.tabs[tab]}><th colSpan="2" className={classes.Section}><FormattedMessage id={this.state.tabs[tab]} /></th></tr>);
            if (tableElementsArray.length === 0) {
                //section.push(<tr key="no_data"><td colSpan="2">Keine Daten</td></tr>);
            } else {
                section = section.concat(tableElementsArray.map((element, i) => (
                    <tr key={element.id + i}>
                        <th className={[classes.Mandatory, (this.state.mode === 'edit' ?  StructureMapping.isMandatoryEdit(element.obj) : "")].join(' ')}><FormattedMessage id={element.intl} defaultMessage={element.name} /></th>
                        <td className={[classes.Fail, (this.state.fail.length && (this.state.fail.indexOf(element.id) !== -1))].join(' ')}>{element.field}</td>
                    </tr>
                )));
            }
            content = content.concat(section);
        }

		return content;
    }

    createElements = (tab) => {
        let elementsArray = [];

        for (let key in this.state.elements) {
            // if (this.showField(tab, key) && this.checkMediaType(key)) {
            if ((!isTranscoder1() && (this.showField(tab, key) && this.checkMediaType(key))) || isTranscoder1()) {
                let element = this.getElement(key);

                if (element && !StructureMapping.isHidden(element.obj)) {
                    let condition = StructureMapping.isCondition(element.obj);
                    if(condition) {
                        if(MetadataElementHelper.isConditionSuccess(condition, this.state.elements)) {
                            elementsArray.push(element);
                        }
                    } else {
                        elementsArray.push(element);
                    }
                }
            }
        }

        return elementsArray.sort(StructureMapping.sortByOrder);
    }

    showField = (tab, field) => {
        if (!tab || !field) {
            return false;
        }

        if (!MetadataPermissionHelper.hasFieldPermission(this.props, field, 'see')) {
            return false;
        }

        if (!this.structures.lang[this.state.lang] || !this.structures.lang[this.state.lang].includes(field)) {
            return false;
        }

        if (this.structures.tabs[tab] && this.structures.tabs[tab].includes(field)) {
            return true;
        }

        return false;
    }

    checkMediaType = (key) => {
        if (this.props.mediaType != "video") {
            if (key === "duration_technical" || key === "eingebrannteuntertitel") {
                return false;
            }
        }

        if (this.props.mediaType != "pictures") {
            if (key === "aufloesung" || key === "format" || key === "bildformat") {
                return false;
            }
        }

        return true;
    }

    getElement = (key) => {
        const element = MetadataElementHelper.createElement(this.props.type, key, this.state.elements[key]);

        if (this.showDisplayField(element, key)) {
            element.field = MetadataElementHelper.createDisplayField(element, this);
        } else {
            element.field = MetadataElementHelper.createEditField(element, this);
        }

        return element;
    }

    showDisplayField = (element, key) => {
        if (this.state.mode === METADATA_MODE_TEXT) return true;
        if (StructureMapping.isReadonly(element.obj)) return true;
        if (!MetadataPermissionHelper.hasFieldPermission(this.props, key, 'edit')) return true;
        return false;
    }
	
	getExtraPanelButtons = () => {
		if(!this.props.extraPanels || this.props.extraPanels.indexOf(METADATA_CONTENT_SETTING) === -1) { return ""; }
		if(!this.props.data.hasOwnProperty("dlformats") && !this.props.data.hasOwnProperty("medialang")) { return ""; } 
		return (
			<Content 
				content={this.state.content} 
				click={this.toggleContent} />
		);
	}
	
	getContent = () => {
		let content = "";
		switch(this.state.content) {
			case METADATA_CONTENT_METADATA:
				content = this.createMetadata();
				break;
			case METADATA_CONTENT_SETTING:
				content = 	(
								<>
									<RoomSetting 
										room={this.props.data}
										mode={this.state.mode} />
								</>
							)
				break;
			default:
				content = this.createMetadata();
				break;
		}
		
		return (
            <IntlProvider
                key={this.state.lang}
                locale={this.state.lang}
                messages={this.props.config.languages[this.state.lang].messages}
            >

                <FlexColumn className={[classes.Container, "Metadata", this.props.type].join(' ')}>
                    <FlexRow className={classes.Header}>
                        {/*<div><FontAwesomeIcon icon="folder" /></div>*/}
                        <div style={{ flex: 1 }}><FormattedMessage id={this.props.title} /></div>
						{ this.getExtraPanelButtons() }
                        {(this.props.id !== 0 && MetadataPermissionHelper.hasPermission(this.props)) ? <Icon mode={this.state.mode} click={() => this.toggleMode(this.state.mode)} cancel={() => this.toggleMode(METADATA_MODE_CANCEL)} /> : ""}
                        <Lang lang={this.state.lang} click={() => this.toggleLang(this.state.lang)} />
                    </FlexRow>
                    <FlexColumn className={classes.Content}>
                        <table>
                            <tbody>
                                {content}
                            </tbody>
                        </table>
                    </FlexColumn>
                </FlexColumn>

            </IntlProvider>
        );
	}

    render = () => {
        let content = '';
        let overlay = '';

        if (this.props.viewState === Panel.PANEL_VIEW_STATE_OPEN) {
            content = this.getContent();
        }

        if (this.props.loading) {
            overlay = (
                <div className={classes.Overlay}>
                    <Spinner />
                </div>
            );
        }

        const attachedClasses = [classes.Metadata, classes[this.props.viewState], classes[this.state.mode], "relative"];

        return (
            <FlexColumn className={attachedClasses.join(' ')}>
                { this.showMandatoryMessage() }
                {overlay}
                <Toggle open={this.props.open} toggle={this.toggleMetadata} />
                {content}
            </FlexColumn>
        );
    }

    componentWillReceiveProps(nextProps) {
        /*const state = { ...this.state, ...this.defaults.state, ...this.initState(nextProps), lang: this.state.lang }
            this.structures = { ...this.initInternalStructures(nextProps) };
            this.setState({ ...state });*/
        // set only if different type or same type and different id (NAND)
        if (!((nextProps.type === this.props.type) && (nextProps.id === this.props.id))) {
			console.log("FIRST");
            this.props.resetMetadataConditional();
            const state = { ...this.state, ...this.defaults.state, ...this.initState(nextProps), lang: this.state.lang, fail: [], failMessage: "" }
            this.structures = { ...this.initInternalStructures(nextProps) };
            this.setState({ ...state });
        } else if(nextProps.conditional.length && nextProps.message) {
			console.log("SECOND");
			const state = { ...this.state, fail: nextProps.conditional, failMessage: nextProps.message };
			this.setState({ ...state });	
        } else if(nextProps.loading === false && this.props.loading === true) {
			console.log("THIRD");
			this.props.resetMetadataConditional();
            const state = { ...this.state, ...this.defaults.state, ...this.initState(nextProps), lang: this.state.lang, fail: [], failMessage: "", content: this.state.content }
            this.structures = { ...this.initInternalStructures(nextProps) };
            this.setState({ ...state });
		}
    }
}

const Toggle = (props) => {
    let attachedClasses = ["pointer"];

    if (props.open) {
        attachedClasses.push(classes.ToggleOpen);
        return (
            <FlexRow className={attachedClasses.join(' ')}>
                <Button
                    btnType="Transparent"
                    clicked={props.toggle}>
                    <FontAwesomeIcon icon="chevron-right" /> <FormattedMessage id="sidebar.minimize" /> <FormattedMessage id="sidebar.metadata" />
                </Button>
            </FlexRow>
        );
    }

    attachedClasses.push(classes.ToggleClosed);
    return (
        <FlexRow className={attachedClasses.join(' ')}>
            <Button
                btnType="Transparent"
                clicked={props.toggle}>
                <FontAwesomeIcon icon="chevron-left" />
            </Button>
        </FlexRow>
    );
}

const Icon = (props) => {
    if (props.mode === METADATA_MODE_TEXT) {
        return <div className="pointer" onClick={props.click}><span className={classes.Btn}><FontAwesomeIcon icon="pen" /></span></div>
    }
    return <div className="pointer" onClick={props.click}><span className={classes.Btn}><FontAwesomeIcon icon="save" /></span></div>;

    // TODO
    // if METADATA_MODE_CANCEL -> reset all changes in the local state ...

    /*
    return (<><div className="pointer" onClick={props.click}>
                <span className={classes.Lang}><FontAwesomeIcon icon="save" /></span>
            </div>
            <div className="pointer" onClick={props.cancel}>
                <span className={classes.Lang}><FontAwesomeIcon icon="window-close" /></span>
            </div></>);
    */
}

const Lang = (props) => {
    return <div className="pointer" onClick={props.click}><span className={classes.Btn}>{props.lang}</span></div>
}

const Content = (props) => {
	//return "";
    if (props.content === METADATA_CONTENT_METADATA) {
        return <div className="pointer" onClick={() => props.click(METADATA_CONTENT_SETTING)}><span className={classes.Btn}><FontAwesomeIcon icon="cog" /></span></div>
    }
    return <div className="pointer" onClick={() => props.click(METADATA_CONTENT_METADATA)}><span className={classes.Btn}><FontAwesomeIcon icon="folder" /></span></div>;
}

const mapStateToProps = (state) => {
    return {
        viewState: state.ui.metadataState,
        open: state.ui.metadataState === Panel.PANEL_VIEW_STATE_OPEN,
        appLang: state.ui.language,
        user: state.auth.user,
        users: state.user.users,
        config: state.ui.config,
        loading: state.metadata.loading,
        conditional: state.metadata.conditional,
        message: state.metadata.message
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        opened: () => dispatch(actions.metadataOpened()),
        closed: () => dispatch(actions.metadataClosed()),
        updateMetadata: (type, id, metadata, reloads) => dispatch(actions.updateMetadata(type, id, metadata, reloads)),
        reloadComponent: (reloads, id) => dispatch(actions.reloadComponent(reloads, id)),
        addMemberToProject: (id, member) => dispatch(actions.addMemberToProject(id, member)),
        delMemberFromProject: (projectId, memberId) => dispatch(actions.delMemberFromProject(projectId, memberId)),
        loadUsers: () => dispatch(actions.userGetUsers()),
        resetMetadataConditional: () => dispatch(actions.resetMetadataConditional())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(Metadata));
